import PropTypes from 'prop-types';
import * as React from 'react';
import GradesTasksTopIcon from './GradesTasksTopIcon';

function GradesTasksHeader({ tasks }) {
  return (
    <div className="grades-top-row">
      {tasks.map(t => (
        <GradesTasksTopIcon key={'top-icon' + t.id} task={t} />
      ))}
    </div>
  );
}

GradesTasksHeader.propTypes = {
  tasks: PropTypes.array.isRequired
};

export default GradesTasksHeader;
